module.exports = __webpack_public_path__ + "static/media/02-homepage2.b6dc9e49.png";